import { Store } from 'laco'
import { cookieStringToObject } from 'Helpers'

import VirtualOfficeService from 'Services/virtual-offices'
import AuthService from 'Services/auth'

import config from 'Config'

const UserStore = new Store()

export async function updateUserStore() {
  const cookies = cookieStringToObject()

  UserStore.set(() => ({
    isLoggedIn: Boolean(cookies[config.loggedInCookie]),
    virtualOffices: undefined,
    user: cookies.user,
    token: cookies[config.loggedInCookie]
  }))

  if (cookies[config.loggedInCookie]) {
    const user = await AuthService.get()
    UserStore.set(() => ({ user }))
    return VirtualOfficeService.list().then(data => UserStore.set(() => ({ virtualOffices: data })))
  }
}

export async function login({ username, password }) {
  const response = await AuthService.login({
    username,
    password
  })
  updateUserStore()
  return response
}

export async function setupAccount({ username, password, inviteCode }) {
  const response = await AuthService.setupAccount({
    username,
    password,
    inviteCode
  })
  updateUserStore()
  return response
}

updateUserStore()

export default UserStore
